const api = `${process.env.API_URL}/`;
export function apiUrl(uri = ""): string {
  if (uri.startsWith("/"))
    throw new TypeError(
      `Api request urls must not start with a slash. Request to url: \`${uri}\` contains a leading slash.`,
    );
  // 'next'/'previous' links have the api url baked in
  return `${api}${uri.replace(api, "")}`;
}
